import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-photo-input',
    templateUrl: './photo-input.component.html',
    styleUrls: ['./photo-input.component.scss']
})
export class PhotoInputComponent implements OnInit, OnChanges {
    @Input() carouselPhotos = [];
    @Input() numVisibleItems = 1;
    @Input() showValidations = false;
    @Input() readonly = false;

    @Output() changeFiles = new EventEmitter<any>();

    uploadedPhotos = [];

    constructor() {
    }

    ngOnChanges(changes: SimpleChanges): void {
    }

    ngOnInit() {
    }

    selectFiles(event: any[]) {
        this.uploadedPhotos = event;
    }

    selectCarouselFiles(event: any) {
        this.carouselPhotos = this.carouselPhotos.filter(item => item.id !== event.id);
        this.changeFiles.emit(event);
    }

    get uploadedImages() {
        return this.uploadedPhotos;
    }

    get carouselImages() {
        return this.carouselPhotos;
    }

    get visiblePhotos() {
        return this.carouselPhotos.length >= this.numVisibleItems ? this.numVisibleItems : this.carouselPhotos.length - 1;
    }

}
